"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./StarRating.scss");
var key_press_1 = require("../../../utils/key-press");
var Star_1 = require("./components/Star");
var StarRating = function (_a) {
    var _b = _a.data, data = _b === void 0 ? {} : _b, _c = _a.options, options = _c === void 0 ? {} : _c, _d = _a.events, events = _d === void 0 ? {} : _d, testId = _a.testId;
    var _e = __read(React.useState(true), 2), hideFocus = _e[0], setHideFocus = _e[1];
    var rating = data && data.rating ? data.rating : 0;
    var ratingsArr = [];
    var remainder = Math.floor(rating);
    var ratingTimesTen = Math.floor(rating * 10);
    var modulus = (ratingTimesTen % 10) / 10;
    var isInteractive = options && options.isInteractive === false ? false : true;
    var reviews = data.reviews;
    if (typeof reviews === "number") {
        reviews = reviews.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    for (var i = 0; i < remainder; i++) {
        ratingsArr[i] = 1;
    }
    for (var i = remainder; i < 5; i++) {
        if (i === remainder) {
            ratingsArr[i] = modulus;
        }
        else {
            ratingsArr[i] = 0;
        }
    }
    if (options && options.showWriteAReview) {
        return (React.createElement("div", { className: "flex flex-items-center" + (options.className ? " " + options.className : ""), "data-testid": testId, id: testId },
            React.createElement("a", { className: "font-medium link-text" + (options.onDark ? "" : "3") + " type-xs", href: options.linkHref ? options.linkHref : undefined, onClick: events && events.linkOnClick ? events.linkOnClick : undefined, style: __assign({ cursor: "pointer" }, (options.onDark ? { color: "#fff" } : {})), tabIndex: 0 }, "Write a review")));
    }
    var onFocus = function () {
        setHideFocus(true);
    };
    var onKeyDown = function (e) {
        if (key_press_1.KeyPress.enterIsPressed(e) || key_press_1.KeyPress.spaceIsPressed(e)) {
            e.preventDefault();
        }
    };
    var onKeyUp = function (e) {
        if (key_press_1.KeyPress.tabIsPressed(e) || key_press_1.KeyPress.enterIsPressed(e) || key_press_1.KeyPress.spaceIsPressed(e)) {
            setHideFocus(false);
        }
        if (key_press_1.KeyPress.enterIsPressed(e) || key_press_1.KeyPress.spaceIsPressed(e)) {
            e.preventDefault();
            if (events && events.onClick) {
                events.onClick();
            }
        }
    };
    var onMouseDown = function (e) {
        e.preventDefault();
        setHideFocus(true);
    };
    var onMouseUp = function (e) {
        e.preventDefault();
        if (events && events.onClick) {
            events.onClick();
        }
    };
    if (isInteractive) {
        return (React.createElement("div", { "aria-label": options && options.ariaLabel
                ? options.ariaLabel
                : "Rated " + ratingTimesTen / 10 + " out of 5 stars" + (data && data.reviews ? " with " + data.reviews + " reviews" : ""), className: "inline-flex flex-items-center line-h-sm type-xs " + styles.starRating + " " + styles.starRatingElements + " " + (hideFocus
                ? ""
                : !(options && options.onDark)
                    ? " " + styles.starRatingFocusA
                    : " " + styles.starRatingFocusB) + (options && options.className ? " " + options.className : ""), id: testId, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseUp: onMouseUp, role: "button", tabIndex: 0 },
            ratingsArr.map(function (item, index) { return (React.createElement(Star_1.default, { isLast: index === 4, key: index, onDark: options && options.onDark ? options.onDark : false, value: item })); }),
            React.createElement("span", { className: styles.spanA + " " + (!(options && options.onDark) ? "color-ui-dark-gray" : "color-ui-white") }, Math.floor(ratingTimesTen / 10) + "." + ratingTimesTen % 10),
            data && data.reviews && (React.createElement("span", { className: styles.spanB + " " + (!(options && options.onDark) ? "color-ui-gray" : "color-ui-medium-gray") }, "|")),
            data && data.reviews && (React.createElement("span", { className: styles.spanC + " " + (!(options && options.onDark) ? "color-ui-dark-gray" : "color-ui-white") }, reviews))));
    }
    else {
        return (React.createElement("div", { className: "inline-flex flex-items-center line-h-sm type-xs " + styles.starRatingElements + "\n                    " + (options && options.className ? " " + options.className : ""), id: testId, tabIndex: -1 },
            React.createElement("span", { className: "hidden-spoken" }, options && options.ariaLabel
                ? options.ariaLabel
                : "Rated " + ratingTimesTen / 10 + " out of 5 stars" + (data && data.reviews ? " with " + data.reviews + " reviews" : "")),
            ratingsArr.map(function (item, index) { return (React.createElement(Star_1.default, { isLast: index === 4, key: index, onDark: options && options.onDark ? options.onDark : false, value: item })); }),
            React.createElement("span", { className: styles.spanA + " " + (!(options && options.onDark) ? "color-ui-dark-gray" : "color-ui-white"), "aria-hidden": true }, Math.floor(ratingTimesTen / 10) + "." + ratingTimesTen % 10),
            data && data.reviews && (React.createElement("span", { className: styles.spanB + " " + (!(options && options.onDark) ? "color-ui-gray" : "color-ui-medium-gray"), "aria-hidden": true }, "|")),
            data && data.reviews && (React.createElement("span", { className: styles.spanC + " " + (!(options && options.onDark) ? "color-ui-dark-gray" : "color-ui-white"), "aria-hidden": true }, reviews))));
    }
};
exports.default = StarRating;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/StarRating/StarRating.js
// module id = 1813
// module chunks = 8